import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Core from "../Core";

import { Button, Form, FormGroup, ControlLabel, FormControl } from "react-bootstrap";

class LicenseDetailPage extends Component {
    getCurrentLicense() {
        const { stores, id } = this.props;
        const license = stores.data.LicensesStore.findById(id);
        return license;
    }

    onSaveClick() {
        const { stores } = this.props;

        const license = this.getCurrentLicense();
        if (license) {
            if (
                !(parseInt(license.TypeId, 10) === stores.data.Enums.LicenseTypes.RENTAL.Key && (license.EndDate === null || license.EndDate === undefined))
            ) {
                license.store.storeModel(license, () => {
                    window.location.hash = `#licenses-list?customerId=` + license.CustomerId;
                });
            }
        }
    }

    onCancelClick() {
        window.history.back();
    }

    onApplicationChange(e) {
        const item = this.getCurrentLicense();
        item.ApplicationId = e.target.value;
    }

    onLicenseTypeChange(e) {
        const item = this.getCurrentLicense();
        item.TypeId = e.target.value;
    }

    validateValue(value, required = true) {
        let validationState = null;

        if (required && (value === null || value === undefined || value.length === 0)) {
            validationState = "error";
        }

        return validationState;
    }

    render() {
        const { stores } = this.props;

        const license = this.getCurrentLicense();
        if (!license) throw new Error("License cannot be null");

        const applicationRows = stores.data.ApplicationsStore.map(application => {
            return (
                <option key={application.Id} value={application.Id}>
                    {application.Name}
                </option>
            );
        });

        let validateEndDate = false;
        if (parseInt(license.TypeId, 10) === stores.data.Enums.LicenseTypes.RENTAL.Key) validateEndDate = true;

        let licenseTypeRows = [];
        for (let pair of stores.data.Enums.LicenseTypes.List) {
            var [key, value] = pair;
            licenseTypeRows.push(
                <option key={key} value={key}>
                    {value.Name}
                </option>
            );
        }

        return (
            <div>
                <div className="row">
                    <h1>License details</h1>
                </div>

                <Form className="well">
                    <div className="row">
                        <FormGroup className="col-sm-4" validationState={this.validateValue(license.ApplicationId, true)}>
                            <ControlLabel>Application</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="select"
                                defaultValue={license.ApplicationId}
                                required={true}
                                onChange={this.onApplicationChange.bind(this)}
                            >
                                <option value="">Select</option>
                                {applicationRows}
                            </FormControl>
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-2" validationState={this.validateValue(license.TypeId, true)}>
                            <ControlLabel>Type</ControlLabel>
                            <FormControl
                                componentClass="select"
                                placeholder="select"
                                defaultValue={license.TypeId}
                                required={true}
                                onChange={this.onLicenseTypeChange.bind(this)}
                            >
                                <option value="">Select</option>
                                {licenseTypeRows}
                            </FormControl>
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-2" validationState={this.validateValue(license.Number, true)}>
                            <ControlLabel>Number of licenses</ControlLabel>
                            <Core.Components.Inputs.Text type={"number"} model={license} dataMember={"Number"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-2" validationState={this.validateValue(license.EndDate, validateEndDate)}>
                            <ControlLabel>End date</ControlLabel>
                            <Core.Components.Inputs.Date model={license} dataMember={"EndDate"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-6">
                            <ControlLabel>Internal remark</ControlLabel>
                            <Core.Components.Inputs.Text rows="5" componentClass="textarea" model={license} dataMember={"InternalRemark"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <FormGroup className="col-sm-4">
                            <ControlLabel>Last updated</ControlLabel>
                            <Core.Components.Inputs.Date model={license} timeFormat={true} dataMember={"LastUpdated"} readOnly={"readOnly"} />
                        </FormGroup>
                    </div>

                    <div className="row">
                        <div className="pull-right">
                            <Button bsStyle="primary" onClick={this.onSaveClick.bind(this)}>
                                Save
                            </Button>
                            <Button bsStyle="link" onClick={this.onCancelClick.bind(this)}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
}

export default inject("stores")(observer(LicenseDetailPage));



// WEBPACK FOOTER //
// ./src/Pages/LicenseDetailPage.js